import SkeletonBar from "../../shared/SkeletonBar";

export function StatCardSkeleton() {
    return (
        <div
            className="surface-card relative flex min-h-[80px] items-center px-4 py-3 sm:min-h-[92px] md:min-h-[108px] md:px-6 md:py-5"
            aria-hidden
        >
            <SkeletonBar className="absolute right-2 top-1/2 h-8 w-8 -translate-y-1/2 rounded-lg md:right-5 md:h-12 md:w-12" />
            <div className="relative z-[1] min-w-0 flex-1 pr-8 md:pr-14">
                <SkeletonBar className="h-7 w-14 md:h-10 md:w-20" />
                <SkeletonBar className="mt-2 h-4 w-24" />
                <SkeletonBar className="mt-1.5 h-3 w-20" />
            </div>
        </div>
    );
}

export default function StatsSkeletons({ count = 3, label = "Loading stats" }) {
    return (
        <div
            className="mb-5 grid grid-cols-1 gap-3 md:mb-7 md:grid-cols-3 md:gap-4"
            aria-busy="true"
            aria-label={label}
            role="status"
        >
            <span className="sr-only">{label}</span>
            {Array.from({ length: count }, (_, index) => (
                <StatCardSkeleton key={index} />
            ))}
        </div>
    );
}
